import { render, staticRenderFns } from "./customerSource.vue?vue&type=template&id=748c35fd&scoped=true"
import script from "./customerSource?vue&type=script&lang=js&external"
export * from "./customerSource?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748c35fd",
  null
  
)

export default component.exports